import React, { FC, memo, useEffect, useState } from 'react';
import { Pressable } from 'react-native';

import { useInterval } from '@bonanza-social/toolkit/hooks';
import { Box, Text } from '@bonanza-social/moonlight';

import { OTCInputCellProps } from './OTCInput.types';

const CodeCell: FC<OTCInputCellProps> = ({ value, onPress, isActive }) => {
  const [cursorVisible, setCursorVisible] = useState(false);

  useInterval(
    () => {
      setCursorVisible(!cursorVisible);
    },
    isActive && !value ? 500 : null,
  );

  useEffect(() => {
    setCursorVisible(isActive);
  }, [isActive]);

  return (
    <Pressable onPress={onPress}>
      <Box
        justifyContent="center"
        alignItems="center"
        width="space-1200"
        height="space-1400"
        backgroundColor="inputBackground"
        borderRadius="radius-200"
        borderWidth="border-width-025"
        borderColor={isActive ? 'borderActive' : 'borderSecondary'}
      >
        <Text variant="h5" color="darkSurfacePrimary">
          {value}
        </Text>
        {cursorVisible && !value && (
          <Box
            position="absolute"
            justifyContent="center"
            width={2}
            height={24}
            variant="gradient"
            gradient="accentBackground"
          />
        )}
      </Box>
    </Pressable>
  );
};

export default memo(CodeCell);
